import React from 'react'
import { containerIds } from 'modules/ui'
import PendingEmployeeListItem from 'components/molecules/PendingEmployeeListItem'
import Pager from 'components/business/shared/Pager'

export default class PendingEmployeeList extends React.Component {
  onClick = e => {
    e.preventDefault()
    const { actions } = this.props
    actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
      showPendingList: false,
    })
    const location = {
      search: '?page=1',
    }
    this.props.history.push(location)
  }

  renderEmployees = () => {
    const { company } = this.props

    const employees = company.invitedEmployees.results

    if (employees.length) {
      return (
        <table className="business-reservation__table">
          <thead>
            <tr className="business-reservation__line">
              <th className="business-employee__name-heading">
                {i18n.t('page.employee.l_00008')}
              </th>
              <th className="business-employee__mail-heading">
                {i18n.t('page.employee.l_00023')}
              </th>
            </tr>
          </thead>
          <tbody>
            {employees.map(employee => (
              <PendingEmployeeListItem key={employee.id} employee={employee} />
            ))}
          </tbody>
        </table>
      )
    } else {
      return (
        <table className="business-reservation__table">
          <tbody>
            <tr className="business-reservation__line business-employee__line">
              <td className="business-employee__none" colSpan="3">
                {i18n.t('page.employee.l_00024')}
              </td>
            </tr>
          </tbody>
        </table>
      )
    }
  }

  render() {
    const { match, data } = this.props
    const { results, pageInfo } = data.company.invitedEmployees

    return (
      <div>
        <ul style={{ overflow: 'auto' }}>
          <li className="business-employee__list-tab-current">
            {i18n.t('page.employee.l_00025')}
          </li>
          <a href="" onClick={this.onClick}>
            <li className="business-employee__list-tab">
              {i18n.t('page.employee.l_00026')}
            </li>
          </a>
        </ul>
        <div className="business-employee__table">{this.renderEmployees()}</div>
        {pageInfo.totalPages > 1 && (
          <Pager
            variables={data.variables}
            pathName={match.url}
            pageInfo={pageInfo}
            windowSize={1}
          />
        )}
      </div>
    )
  }
}
